'use strict';

var processInclude = require('core/util');
processInclude(require('zurb-twentytwenty/js/jquery.event.move'));
var twentytwenty = require('zurb-twentytwenty/js/jquery.twentytwenty');

$(document).ready(function () {
    var defaultConfig = {
        default_offset_pct: 0.5, // How much of the before image is visible when the page loads
        orientation: 'horizontal', // Orientation of the before and after images ('horizontal' or 'vertical')
        before_label: '', // Set a custom before label
        after_label: '', // Set a custom after label
        no_overlay: true, //Do not show the overlay with before and after
        move_slider_on_hover: false, // Move slider on mouse hover?
        move_with_handle_only: true, // Allow a user to swipe anywhere on the image to control slider movement. 
        click_to_move: false // Allow a user to click (or tap) anywhere on the image to move the slider to that location.
    };

    $(window).on('load', function () {
        $('.twentytwenty-container').twentytwenty(defaultConfig);
    });
});
